import { render, staticRenderFns } from "./1_BienvenidaEduContinua.vue?vue&type=template&id=53bf17f2&scoped=true"
import script from "./1_BienvenidaEduContinua.vue?vue&type=script&lang=js"
export * from "./1_BienvenidaEduContinua.vue?vue&type=script&lang=js"
import style0 from "./1_BienvenidaEduContinua.vue?vue&type=style&index=0&id=53bf17f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf17f2",
  null
  
)

export default component.exports